<template>
  <div class="flex justify-center gap-2">
    <div>
      <div class="h-lg flex justify-center gap-1">
        <BaseButton class="!min-w-[2rem]" :disabled="page === 1" @click="goToPage(1)">
          <BaseIcon class="h-sm" :icon="Icon.DOUBLE_PREV" />
        </BaseButton>
        <BaseButton class="!min-w-[2rem]" :disabled="page === 1" @click="goToPage(page - 1)">
          <BaseIcon class="h-sm" :icon="Icon.PREV" />
        </BaseButton>
        <BaseButton
          v-for="number in numberButtons"
          :key="number"
          class="!min-w-[2rem]"
          :is-highlighted="page === number"
          @click="goToPage(number)"
        >
          <div>{{ number }}</div>
        </BaseButton>
        <BaseButton class="!min-w-[2rem]" :disabled="page === numberOfPages" @click="goToPage(page + 1)">
          <BaseIcon class="h-sm" :icon="Icon.NEXT" />
        </BaseButton>
        <BaseButton class="!min-w-[2rem]" :disabled="page === numberOfPages" @click="goToPage(numberOfPages)">
          <BaseIcon class="h-sm" :icon="Icon.DOUBLE_NEXT" />
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Icon } from "../../../../assets/icons/Icon";
import BaseButton from "../../../../components/BaseButton.vue";
import BaseIcon from "../../../../components/BaseIcon.vue";

const page = defineModel<number>("page", { required: true });
const numberOfPages = defineModel<number>("numberOfPages", { required: true });

function goToPage(pageNumber: number) {
  if (pageNumber <= numberOfPages.value && pageNumber >= 1) {
    page.value = pageNumber;
  }
}
const maxVisibleButtons = 3;
const numberButtons = computed(() => {
  const sides = Math.floor(maxVisibleButtons / 2);
  const buttons = [];
  buttons.push(page.value);
  for (let i = 1; i <= sides; i++) {
    if (buttons.length >= maxVisibleButtons) break;
    page.value + i <= numberOfPages.value ? buttons.push(page.value + i) : "";
    if (buttons.length >= maxVisibleButtons) break;
    page.value - i >= 1 ? buttons.unshift(page.value - i) : "";
  }
  if (buttons.length < maxVisibleButtons) {
    const firstPosition: number = buttons[0] as number;
    const lastPosition: number = buttons[buttons.length - 1] as number;
    for (let i = 1; i <= maxVisibleButtons; i++) {
      if (buttons.length >= maxVisibleButtons) break;
      lastPosition + i <= numberOfPages.value ? buttons.push(lastPosition + i) : "";

      if (buttons.length >= maxVisibleButtons) break;
      firstPosition - i >= 1 ? buttons.unshift(firstPosition - i) : "";
    }
  }
  return buttons;
});
</script>
